import { render } from "./mainMenu.vue?vue&type=template&id=2ae7ae79&scoped=true"
import script from "./mainMenu.vue?vue&type=script&lang=js"
export * from "./mainMenu.vue?vue&type=script&lang=js"

import "./mainMenu.vue?vue&type=style&index=0&id=2ae7ae79&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae7ae79"]])

export default __exports__